export default "__VITE_ASSET__BOikZf54__"